import {QueryFunctionContext} from 'react-query';
import request from '../../axios';

export const getAllNotifications = async (ctx: QueryFunctionContext) => {
  const {data}: {data: INotificationAdvertisement} = await request.get(
    `/api/v2/store/ad-notifications`,
  );

  return data;
};
